import React from 'react';
import { Card } from '../ui/card';
import { Button } from '../ui/button';
import { Phone, MessageCircle } from 'lucide-react';

const ContactCTA = ({ onWhatsApp, onCall }) => (
  <>
    <div className="space-y-3">
      <Button
        onClick={onWhatsApp}
        size="lg"
        className="w-full bg-green-600 hover:bg-green-700 text-white py-6 text-lg rounded-xl shadow-lg hover:shadow-xl transition-all duration-300"
        data-testid="contact-whatsapp-btn"
      >
        <MessageCircle className="w-5 h-5 mr-2" />
        Jetzt WhatsApp senden
      </Button>
      <Button
        onClick={onCall}
        size="lg"
        variant="outline"
        className="w-full border-2 border-blue-600 text-blue-600 hover:bg-blue-600 hover:text-white py-6 text-lg rounded-xl shadow-lg hover:shadow-xl transition-all duration-300"
        data-testid="contact-call-btn"
      >
        <Phone className="w-5 h-5 mr-2" />
        Jetzt anrufen
      </Button>
    </div>

    <Card className="p-6 bg-green-50 border-l-4 border-green-600">
      <div className="flex gap-3">
        <MessageCircle className="w-6 h-6 text-green-600 flex-shrink-0 mt-1" />
        <div>
          <h4 className="font-semibold text-slate-900 mb-2">Warum Floria Maler wählen?</h4>
          <ul className="text-slate-700 space-y-1">
            <li>&#10003; 15+ Jahre Erfahrung</li>
            <li>&#10003; Vollversichert & Zertifiziert</li>
            <li>&#10003; Fixpreisgarantie</li>
            <li>&#10003; 24h Rückmeldung</li>
          </ul>
        </div>
      </div>
    </Card>
  </>
);

export default ContactCTA;
